export function capitalize(text: string) {
  return text[0].toLocaleUpperCase() + text.slice(1);
}
